import type { CSSProperties } from 'react';
import { COLORS } from './colors';
import { FONTS } from './typography';

/** Shared player-facing material, matching the creator and saved-character roster. */
export const PLAYER_UI = {
  inkDeep: '#090b12', ink: '#111522', inkRaised: '#181d2a', well: '#0d1019',
  text: '#f4f0e7', secondary: '#c4c4c9', muted: '#a4a7ad',
  brass: '#c9a35c', brassBright: '#f0d18a',
  border: 'rgba(216,181,106,0.24)', softBorder: 'rgba(255,255,255,0.09)',
  success: COLORS.success, danger: COLORS.danger,
  displayFont: FONTS.display, bodyFont: "'Inter', 'Segoe UI', sans-serif",
} as const;

export const PLAYER_THEME_VARS = {
  '--player-ink-deep': PLAYER_UI.inkDeep, '--player-ink': PLAYER_UI.ink,
  '--player-ink-raised': PLAYER_UI.inkRaised, '--player-well': PLAYER_UI.well,
  '--player-text': PLAYER_UI.text, '--player-secondary': PLAYER_UI.secondary,
  '--player-muted': PLAYER_UI.muted, '--player-brass': PLAYER_UI.brass,
  '--player-brass-bright': PLAYER_UI.brassBright, '--player-border': PLAYER_UI.border,
  '--player-soft-border': PLAYER_UI.softBorder, '--player-display-font': PLAYER_UI.displayFont,
  '--player-body-font': PLAYER_UI.bodyFont,
} as CSSProperties;

export function playerPanel(): CSSProperties {
  return { ...PLAYER_THEME_VARS,
    background: `linear-gradient(180deg, ${PLAYER_UI.inkRaised}, ${PLAYER_UI.ink} 55%, ${PLAYER_UI.inkDeep})`,
    color: PLAYER_UI.text, border: `1px solid ${PLAYER_UI.border}`, borderRadius: 14,
    boxShadow: '0 18px 54px rgba(0,0,0,0.38), inset 0 1px 0 rgba(255,255,255,0.035)',
    fontFamily: PLAYER_UI.bodyFont,
  };
}

/** Existing creator/roster CSS keeps its layout while reading one palette. */
export const CREATOR_THEME_VARS = {
  '--cc-ink-deep': PLAYER_UI.inkDeep, '--cc-ink': PLAYER_UI.ink,
  '--cc-ink-raised': PLAYER_UI.inkRaised, '--cc-brass': PLAYER_UI.brass,
  '--cc-brass-bright': PLAYER_UI.brassBright, '--cc-text': PLAYER_UI.text,
  '--cc-muted': PLAYER_UI.muted, '--cc-line': PLAYER_UI.border, '--cc-soft-line': PLAYER_UI.softBorder,
} as CSSProperties;
export const ROSTER_THEME_VARS = {
  '--roster-ink': PLAYER_UI.ink, '--roster-brass': PLAYER_UI.brass,
  '--roster-bright': PLAYER_UI.brassBright, '--roster-text': PLAYER_UI.text,
  '--roster-muted': PLAYER_UI.muted, '--roster-line': PLAYER_UI.border,
} as CSSProperties;
